<template>
    <div class="riskTableAndMeasures">
        <div class="basInfo-table">
            <div class="row">
                <div class="col">纳入风险名单的情形</div>
                <div class="col">{{applyContent}}</div>
                <div class="col">纳入风险名单日期</div>
                <div class="col">{{dataInfoObj.StartEffectiveYear | formatDate("yyyy-MM-dd")}}</div>
            </div>
            <div class="row">
                <div class="col">纳入风险名单年度</div>
                <div class="col">
                    <span v-if="dataInfoObj.EffectiveYear">{{dataInfoObj.EffectiveYear}}年</span>
                </div>
                <div class="col">公示截止日期</div>
                <div class="col">{{deadlineObj.NoticeEndTime | formatDate("yyyy-MM-dd")}}</div>
            </div>
        </div>
        <div class="basInfo-table model-info bg-w">
            <div class="row">
                <div class="title">
                    <span>监管措施</span>
                </div>
            </div>
            <div class="pad-l pad-t pad-r pad-b" v-if="role == 'company'">
                <div class="cont-item">（一）区住房和建设部门对其在管物业项目加强监管，加大检查频次；</div>
                <div class="cont-item">（二）不得获评政府部门和物业服务行业自律组织开展的物业服务有关的先进或者优秀等奖项；</div>
                <div class="cont-item">（三）依法依规限制进入本市政府采购物业服务项目或者其他依法进行招标的物业服务项目；</div>
                <div class="cont-item">（四）法律、法规和党中央、国务院政策文件规定的其他措施。</div>
                <div class="cont-item">涉及的物业服务行业自律组织对纳入风险名单的物业服务企业，采取相关行业自律措施。</div>
            </div>
            <div class="pad-l pad-t pad-r pad-b" v-else>
                <div class="cont-item">（一）区住房和建设部门对其在管物业项目加强监管，加大检查频次；</div>
                <div class="cont-item">（二）在管物业项目所在区住房和建设部门建议物业服务企业更换物业管理项目负责人；</div>
                <div class="cont-item">（三）不得获评政府部门和物业服务行业自律组织开展的物业服务有关的先进或者优秀等奖项；</div>
                <div class="cont-item">（四）法律、法规和党中央、国务院政策文件规定的其他措施。</div>
                <div class="cont-item">涉及的物业服务行业自律组织对纳入风险名单的物业管理项目负责人，采取相关行业自律措施。</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'riskTableAndMeasures',
    props: {
        applyContent: String,
        dataInfoObj: {
            type: Object,
            default: {}
        },
        role: String,
        deadlineObj: Object
    },
    data() {
        return {
            
        };
    },
    created() {
        
    },
    methods: {
        
    }
};
</script>

<style lang="scss" scoped>
.riskTableAndMeasures{
    .row{
        .col:nth-child(2n-1){
            width: 320px;
        }
    }
}
.cont-item{
        line-height: 25px;
    }
</style>